import { yupResolver } from '@hookform/resolvers/yup';
import AddIcon from '@mui/icons-material/Add';
import InfoIcon from '@mui/icons-material/Info';
import { Button, IconButton, Stack, Tooltip } from '@mui/material';
import PageHeaderText from 'layout/pages/PageHeaderText';
import PageHeaderWrapper from 'layout/pages/PageHeaderWrapper';
import { isNil } from 'lodash';
import { observer } from 'mobx-react-lite';
import { useContext } from 'react';
import { FormContainer, TextFieldElement, useForm } from 'react-hook-form-mui';
import StoreContext from 'stores/context/StoreContext';
import { object, string } from 'yup';
import type { FC } from 'react';
import type { SubmitHandler } from 'react-hook-form-mui';

interface ProductsFilterData {
  search: string;
}

const ProductsPageHeader: FC<ProductsPageHeaderProps> = observer(
  ({ onSearchChanged, searchTextInit, onCreateClick }) => {
    const { userStore } = useContext(StoreContext);

    const ability = userStore.ability;
    const canCreate = ability.can('create', 'Tags');

    const schema = object<ProductsFilterData>({
      search: string().max(300),
    }).required();

    const formContext = useForm<ProductsFilterData>({
      mode: 'onChange',
      defaultValues: {
        search: searchTextInit ?? '',
      },
      resolver: yupResolver(schema),
    });

    const filter: SubmitHandler<ProductsFilterData> = (data) => {
      !isNil(onSearchChanged) && onSearchChanged(data.search);
    };

    return (
      <PageHeaderWrapper>
        <Stack direction={'row'} gap={0.2} alignItems='baseline'>
          <PageHeaderText align={['center', 'left']} text='Теги' />
          <Tooltip
            describeChild
            title='Теги помогают группировать товары, упрощают поиск и анализ, а также обеспечивают гибкость в управлении данными. Используйте их для маркировки товаров по категориям, сезонности, акциям или другим критериям.'>
            <IconButton size='small' aria-label='Подробнее о тегах'>
              <InfoIcon fontSize='small' />
            </IconButton>
          </Tooltip>
        </Stack>
        <Stack direction={'row'} spacing={1} sx={{ alignItems: 'center' }}>
          <FormContainer
            FormProps={{ style: { flexGrow: 1 } }}
            formContext={formContext}
            onSuccess={filter}>
            <TextFieldElement
              size='small'
              fullWidth
              name='search'
              placeholder='Поиск'
              type='search'
            />
          </FormContainer>
          {/* </Box> */}
          {canCreate && (
            <Button startIcon={<AddIcon />} onClick={onCreateClick} variant='contained'>
              Создать
            </Button>
          )}
        </Stack>
      </PageHeaderWrapper>
    );
  }
);

export interface ProductsPageHeaderProps {
  searchTextInit?: string;
  onSearchChanged?: (text: string) => void;
  onCreateClick?: VoidFunction;
}

export default ProductsPageHeader;
